import { defineComponent } from 'vue'
import NumberHistoryChart from '@/components/number-history-chart'

export default defineComponent({
  name: 'RegularHistoryPage',
  setup() {
    return () => <NumberHistoryChart type={1} />
  },
})
